import { useQuery } from 'react-query';

import { PageBoundingBox } from '../../../../backend/src/matter/fact/fact-bounding-box';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface KimThreadFileChunkResponse {
  id: string;
  content: string;
  boundingBox: PageBoundingBox;
  file: {
    id: string;
    name: string;
    extension: string;
    url: string;
  };
}

export const useGetKimThreadFileChunk = (
  matterId?: string,
  subsetId?: string,
  threadId?: string,
  chunkId?: string | null,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<KimThreadFileChunkResponse, ApiError>(
    [QueryEntity.KimThreadFileChunk, { chunkId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/file-chunks/${chunkId}`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(res.status, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId && !!threadId && !!chunkId,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => error.code !== 404 && failureCount < 3,
    },
  );
};
